import React from "react";
import { DetailSidePanel } from "../DetailSidePanel";
import { GuestSidePanelDetails } from "./GuestSidePanelDetails";
import { SidePanelDeleteEntryButton } from "../SidePanelDeleteEntryButton";
import { useOpenSidePanel } from "../SidePanel";
import { useQueryClient } from "@tanstack/react-query";

export const useOpenGuestSidePanel = () => {
  const openSidePanel = useOpenSidePanel();
  const queryClient = useQueryClient();

  const openGuestSidePanel = React.useCallback((guest: server.dto.Guest, guestlistId: number) => {
    openSidePanel(<DetailSidePanel
      apiCall={() => window.CoreApi.Guestlist.GetSidePanelData(guestlistId)}
      apiKey="guest"
      entityId={guest.guestId}
      title={RESX.Guestlist.Guest}
      footerContent={<>
        <SidePanelDeleteEntryButton
          apiCall={async () => {
            const resp = await window.CoreApi.Guestlist.DeleteGuest({ guestId: guest.guestId }, { toastOnError: true });
            queryClient.invalidateQueries(["guestlist"]);
            return resp;
          }}
        />
      </>}
      skipSidePanelBase
    >
      {(data) => <GuestSidePanelDetails
        data={data}
        guest={guest}
      />}
    </DetailSidePanel>, `guest-side-${guest.guestId}`, "medium");
  }, [openSidePanel]);

  return openGuestSidePanel;
}